import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type Row } from '@tanstack/table-core';
    import { Checkbox } from '@/components/ui/checkbox';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableTdCheckbox',
  props: {
    row: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Checkbox), {
    "model-value": _ctx.row.getIsSelected(),
    disabled: !_ctx.row.getCanSelect(),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => _ctx.row.toggleSelected(!!value)),
    "aria-label": "Select row"
  }, null, 8, ["model-value", "disabled"]))
}
}

})